import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { Tooltip, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/en";
import { Field, useFormikContext } from "formik";
import React, { useEffect } from "react";
import CommonTextField from "../../../../component/Input";
import DropDownSelect from "../../../../component/Select";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomDatePicker } from "../../../coversheet/components/style";
import { ErrorContent } from "../../style";
import DateRangePickerComp from "../../common-card.js/DatePicker";
import CommonPhoneInput from "../../../../component/PhoneInput";
import { AutocompleteText } from "../../../../component/AutoComplete";

const SubmissionMixedComponent = ({ editData, loading, marginTop }) => {
  const { values, errors, setFieldValue, handleBlur } = useFormikContext();

  const [localValue, setLocalValue] = React.useState({
    bill_rate_to_client: values.bill_rate_to_client || "",
    discounts_applied: values.discounts_applied || "",
    linkedin_profile: values.linkedin_profile || "",
    pay_rate_to_client: values.pay_rate_to_client || "",
    ssn_digits: values.ssn_digits || "",
    bill_currency_to_client: values.bill_currency_to_client || "USD",
    pay_currency_to_client: values.pay_currency_to_client || "USD",

    client: values.client || "",
    job_id: values.job_id || "",
    position_title: values.position_title || "",
    project_duration: values.project_duration || "",
    work_authorization: values.work_authorization || "",
    target_bill_rate: values.target_bill_rate || "",

    first_name: values.first_name || "",
    middle_name: values.middle_name || "",
    last_name: values.last_name || "",
    title: values.title || "",
    location: values.location || "",
    job_location: values.job_location || "",
    email: values.email || "",
    phone_number: values.phone_number || "",
    department: values.department || "",
    extension_phone: values.extension_phone || "",
    manager_name: values.manager_name || "",
    emplopyer_name: values.emplopyer_name || "",
    emplopyer_phone: values.emplopyer_phone || "",
    emplopyer_email: values.emplopyer_email || "",
    emplopyer_contact_name: values.emplopyer_contact_name || "",
    H1B_holder_company_name: values.H1B_holder_company_name || "",
    min: values["rate"]?.["min"] || "",
    max: values["rate"]?.["max"] || "",
    linkedin_url: values.linkedin_url || "",
    portfolio: values.portfolio || "",
    hour_rate: values.hour_rate || "",
    contract_hour_rate: values.contract_hour_rate || "",
    employee_hour_rate: values.employee_hour_rate || "",
    certificates_value: values.certificates_value || "",
    industry_value: values.industry_value || "",
    languages_value: values.languages_value || "",
    notice_period: values.notice_period || "",
    location_value: values.location_value || "",
  });

  useEffect(() => {
    setLocalValue({
      bill_rate_to_client: values.bill_rate_to_client || "",
      discounts_applied: values.discounts_applied || "",
      linkedin_profile: values.linkedin_profile || "",
      pay_rate_to_client: values.pay_rate_to_client || "",
      ssn_digits: values.ssn_digits || "",
      bill_currency_to_client: values.bill_currency_to_client || "USD",
      pay_currency_to_client: values.pay_currency_to_client || "USD",

      client: values.client || "",
      job_id: values.job_id || "",
      position_title: values.position_title || "",
      project_duration: values.project_duration || "",
      work_authorization: values.work_authorization || "",
      target_bill_rate: values.target_bill_rate || "",

      first_name: values.first_name || "",
      middle_name: values.middle_name || "",
      last_name: values.last_name || "",
      title: values.title || "",
      location: values.location || "",
      job_location: values.job_location || "",
      email: values.email || "",
      phone_number: values.phone_number || "",
      department: values.department || "",
      manager_name: values.manager_name || "",
      extension_phone: values.extension_phone || "",
      emplopyer_name: values.emplopyer_name || "",
      emplopyer_phone: values.emplopyer_phone || "",
      emplopyer_email: values.emplopyer_email || "",
      emplopyer_contact_name: values.emplopyer_contact_name || "",
      H1B_holder_company_name: values.H1B_holder_company_name || "",
      min: values["rate"]?.["min"] || "",
      max: values["rate"]?.["max"] || "",
      linkedin_url: values.linkedin_url || "",
      portfolio: values.portfolio || "",
      hour_rate: values.hour_rate || "",
      contract_hour_rate: values.contract_hour_rate || "",
      employee_hour_rate: values.employee_hour_rate || "",
      certificates_value: values.certificates_value || "",
      industry_value: values.industry_value || "",
      languages_value: values.languages_value || "",
      notice_period: values.notice_period || "",
      location_value: values.location_value || "",
    });
  }, [values]);

  const debounceTimer = React.useRef(null);

  const handleInputChange = (e, item) => {
    setLocalValue((prev) => ({
      ...prev,
      [item.titleName]: e.target.value,
    }));
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setFieldValue(item.titleName, e.target.value);
    }, 500);
  };

  const handleCurrencyEnter = (e, item) => {
    setLocalValue((prev) => ({
      ...prev,
      [item.titleName]: e.target.value,
    }));
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setFieldValue(item.titleName, e.target.value);
    }, 500);
  };

  const handleCurrencyDropdownChange = (event, name, currencyValue) => {
    const exchangeRate = 83;
    function convertUsdToInr(usdValue) {
      return usdValue * exchangeRate;
    }

    function convertInrToUsd(inrValue) {
      return inrValue / exchangeRate;
    }

    const updatedPayRate = {
      ...localValue,
      [currencyValue]: event.target.value,
      [name]:
        event.target.value === "INR"
          ? convertUsdToInr(localValue[name])
          : convertInrToUsd(localValue[name]),
    };

    setLocalValue(updatedPayRate);

    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setFieldValue(currencyValue, event.target.value);
      setFieldValue(
        name,
        event.target.value === "INR"
          ? convertUsdToInr(localValue[name])
          : convertInrToUsd(localValue[name])
      );
    }, 500);
  };

  const handleNumberChange = (e, countryData, item) => {
    const getValue = e;
    setLocalValue((prev) => ({
      ...prev,
      [item.titleName]: e,
    }));
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    debounceTimer.current = setTimeout(() => {
      setFieldValue(item.country, countryData);
      setFieldValue(item.titleName, getValue);
    }, 300);
  };

  const handleInputNumberChange = (e, innerItem) => {
    const inputVal = e.target.value;
    const hasFormat = !!values.phone_number_country?.format;

    let processedValue = inputVal;

    if (hasFormat) {
      const digitsOnly = inputVal.replace(/\D/g, "");
      const numberFormat = getNumberFormatWithoutDialCode(
        values.phone_number_country.format
      );
      const maxDigits = (numberFormat.match(/\./g) || []).length;
      processedValue = digitsOnly.slice(0, maxDigits);
    }

    setLocalValue((prev) => ({
      ...prev,
      [innerItem.titleName]: processedValue,
    }));

    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    debounceTimer.current = setTimeout(() => {
      setFieldValue(innerItem.titleName, processedValue);
    }, 500);
  };

  const getNumberFormatWithoutDialCode = (format) => {
    return format?.replace(/^\+\.+\s*/, "") || "";
  };

  const formatPhoneNumber = (digits, format) => {
    let result = "";
    let digitIndex = 0;

    for (let i = 0; i < format.length; i++) {
      const char = format[i];
      if (char === ".") {
        if (digitIndex < digits.length) {
          result += digits[digitIndex++];
        } else {
          break;
        }
      } else {
        if (digitIndex < digits.length) {
          result += char;
        } else {
          break;
        }
      }
    }

    return result;
  };

  const getFormattedValue = (value) => {
    const fullFormat = values.phone_number_country?.format;
    const numberFormat = getNumberFormatWithoutDialCode(fullFormat);
    return formatPhoneNumber(value || "", numberFormat);
  };

  return (
    <CommonGrid2
      container
      columnSpacing={3}
      rowSpacing={loading ? 0 : 3}
      marginTop={marginTop}
    >
      {editData?.map((item, index) => {
        return (
          <CommonGrid2
            item
            size={{
              xs: 12,
              md: item.size || 4,
              sm: 6,
            }}
            key={item.title}
            gap={"5px"}
            display={"flex"}
            flexDirection={item.component === "switch" ? "row" : "column"}
            justifyContent={"flex-start"}
          >
            {loading ? (
              <HandleSkeletion height={100} />
            ) : (
              <>
                {item.component !== "split-screen" && (
                  <CommonGrid2
                    display={"flex"}
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    width={"100%"}
                  >
                    <CommonGrid2
                      display={"flex"}
                      alignItems={"center"}
                      width={"100%"}
                      gap={"10px"}
                    >
                      <Typography variant="p" color="#344054" fontSize="15px">
                        {item.title}
                      </Typography>
                    </CommonGrid2>
                  </CommonGrid2>
                )}
                {item.component === "input" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      return (
                        <CommonTextField
                          {...field}
                          placeholder={
                            item?.placeholder ? item?.placeholder : item.title
                          }
                          disabled={item?.disabled}
                          padding="10px"
                          error={Boolean(
                            form.touched[item.titleName] &&
                              form.errors[item.titleName]
                          )}
                          maxLength={item.maxLength}
                          placeholderFontSize={item?.placeholderFontSize}
                          helperText={
                            form.touched[item.titleName] &&
                            form.errors[item.titleName]
                          }
                          value={localValue[item.titleName]}
                          onChange={(e) => handleInputChange(e, item)}
                        />
                      );
                    }}
                  </Field>
                )}
                {item.component === "input-select" && (
                  <CommonTextField
                    showSelect={true}
                    placeholder={item.placeholder}
                    menuItemData={item.menuItemData}
                    onChange={(e) => {
                      handleCurrencyEnter(e, item);
                    }}
                    currency={localValue[item.currency]}
                    padding="10px"
                    handleCurrencyChange={(e) =>
                      handleCurrencyDropdownChange(
                        e,
                        item.titleName,
                        item.currency
                      )
                    }
                    error={errors[item.titleName]}
                    helperText={errors[item.titleName]}
                    value={localValue?.[item.titleName]}
                    disabled={item.disabled}
                  />
                )}
                {item.component === "dropDown" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      const handleDropdownChange = (event) => {
                        form.setFieldValue(item.titleName, event.target.value);
                      };

                      return (
                        <DropDownSelect
                          marginTop="0px"
                          title={
                            item?.placeholder ? item?.placeholder : item.title
                          }
                          disabled={item?.disabled}
                          removeAnimation={true}
                          data={form.values[item.dropDownData]}
                          error={Boolean(
                            form.touched[item.titleName] &&
                              form.errors[item.titleName]
                          )}
                          helperText={
                            form.touched[item.titleName] &&
                            form.errors[item.titleName]
                          }
                          value={form.values[item.titleName]}
                          handleChange={handleDropdownChange}
                          // customStyle={{
                          //   "& .MuiFormLabel-root-MuiInputLabel-root": {
                          //     fontSize: "14px",
                          //   },
                          // }}
                        />
                      );
                    }}
                  </Field>
                )}
                {item.component === "dob_month" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      const isError =
                        form.touched[item.titleName] &&
                        Boolean(form.errors[item.titleName]);

                      const helperText = isError
                        ? form?.errors[item.titleName]
                        : "";

                      return (
                        <>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <CustomDatePicker
                              disabled={item.disabled}
                              onChange={(newValue) => {
                                const formattedDate = newValue
                                  ? dayjs(newValue).format("DD MMM")
                                  : "";

                                form.setFieldValue(
                                  item?.titleName,
                                  formattedDate
                                );
                              }}
                              value={
                                form?.values?.[item?.titleName]
                                  ? dayjs(form.values[item.titleName], "DD MMM")
                                  : null
                              }
                              openTo="month"
                              format={"DD MMM"}
                              error={isError}
                              views={["month", "day"]}
                              slots={{
                                calendarHeader: (props) => (
                                  <CustomDiv
                                    padding={"1rem 2rem"}
                                    fontSize="16px"
                                    fontWeight={600}
                                  >
                                    {dayjs(props.currentMonth).format("MMMM")}
                                  </CustomDiv>
                                ),
                                openPickerIcon: () => (
                                  <CommonGrid2
                                    display={"flex"}
                                    fontSize={"15px"}
                                    gap={"5px"}
                                    alignItems={"center"}
                                    color={"#000"}
                                    fontWeight={600}
                                  >
                                    <CalendarTodayIcon
                                      style={{ height: "20px" }}
                                    />
                                  </CommonGrid2>
                                ),
                              }}
                              slotProps={{
                                textField: {
                                  placeholder: "DD MMM",
                                  disabled: true,
                                  inputProps: { readOnly: true },
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      backgroundColor: "#F2F4F7",
                                      color: "#666",
                                      cursor: "not-allowed",
                                    },
                                  },
                                },
                                popper: {
                                  sx: {
                                    "& .MuiDateCalendar-root": {
                                      height: "auto",
                                      marginBottom: "1rem",
                                    },
                                  },
                                },
                              }}
                            />
                          </LocalizationProvider>
                          {isError && (
                            <ErrorContent
                              margin={"-5px 0px 0px"}
                              className="Mui-error"
                            >
                              {helperText}
                            </ErrorContent>
                          )}
                        </>
                      );
                    }}
                  </Field>
                )}
                {item.component === "calender" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      const isError =
                        form.touched[item.titleName] &&
                        Boolean(form.errors[item.titleName]);

                      const helperText = isError
                        ? form.errors[item.titleName]
                        : "";

                      return (
                        <>
                          <DateRangePickerComp
                            startDateProp={
                              form.values?.[item.titleName]?.start_date
                            }
                            endDateProp={
                              form.values?.[item.titleName]?.end_date
                            }
                            handleChange={(start_date, end_date) => {
                              form.setFieldValue(item.titleName, {
                                start_date: start_date,
                                end_date: end_date,
                              });
                            }}
                            disabled={item.disabled}
                            error={isError}
                          />
                          {isError && <ErrorContent>{helperText}</ErrorContent>}
                        </>
                      );
                    }}
                  </Field>
                )}

                {item.component === "single-calender" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      const isError =
                        form.touched[item.titleName] &&
                        Boolean(form.errors[item.titleName]);

                      const helperText = isError
                        ? form?.errors[item.titleName]
                        : "";

                      return (
                        <>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <CustomDatePicker
                              disabled={item.disabled}
                              onChange={(newValue) => {
                                const formattedDate = newValue
                                  ? dayjs(newValue).format("DD MMM YYYY")
                                  : "";

                                form.setFieldValue(
                                  item?.titleName,
                                  formattedDate
                                );
                              }}
                              value={
                                form?.values?.[item?.titleName]
                                  ? dayjs(
                                      form.values[item.titleName],
                                      "DD MMM YYYY"
                                    )
                                  : null
                              }
                              format={"DD MMM YYYY"}
                              error={isError}
                              views={["year", "month", "day"]}
                              slotProps={{
                                textField: {
                                  disabled: true,
                                  inputProps: { readOnly: true },
                                  sx: {
                                    "& .MuiInputBase-input": {
                                      backgroundColor: "#F2F4F7",
                                      color: "#666",
                                      cursor: "not-allowed",
                                    },
                                  },
                                },
                              }}
                              slots={{
                                openPickerIcon: () => (
                                  <CommonGrid2
                                    display={"flex"}
                                    fontSize={"15px"}
                                    gap={"5px"}
                                    alignItems={"center"}
                                    color={"#000"}
                                    fontWeight={600}
                                  >
                                    <CalendarTodayIcon
                                      style={{ height: "20px" }}
                                    />
                                    <Typography
                                      fontWeight={600}
                                      fontSize={"13px"}
                                    >
                                      Select
                                    </Typography>
                                  </CommonGrid2>
                                ),
                              }}
                            />
                          </LocalizationProvider>
                          {isError && (
                            <ErrorContent
                              margin={"-5px 0px 0px"}
                              className="Mui-error"
                            >
                              {helperText}
                            </ErrorContent>
                          )}
                        </>
                      );
                    }}
                  </Field>
                )}
                {item.component === "hour" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      return (
                        <CommonTextField
                          placeholder={item.placeholder}
                          onChange={(e) => handleInputChange(e, item)}
                          padding="10px"
                          disabled={item.disabled}
                          error={
                            form.touched[item.titleName] &&
                            form.errors[item.titleName]
                          }
                          placeholderFontSize={item?.placeholderFontSize}
                          helperText={
                            form.touched[item.titleName] &&
                            form.errors[item.titleName]
                          }
                          startIcon={"$"}
                          value={localValue[item.titleName]}
                        />
                      );
                    }}
                  </Field>
                )}
                {item.component === "split-screen" && (
                  <CommonGrid2 container spacing={2}>
                    {item.data.map((innerItem) => (
                      <CommonGrid2
                        size={innerItem.size}
                        display={"flex"}
                        flexDirection={"column"}
                        gap={"8px"}
                      >
                        <Tooltip arrow title={innerItem.title} placement="top">
                          <Typography
                            variant="p"
                            color="#344054"
                            fontSize="16px"
                            textOverflow={"ellipsis"}
                            whiteSpace={"nowrap"}
                            overflow={"hidden"}
                          >
                            {innerItem.title}
                          </Typography>
                        </Tooltip>
                        {innerItem.component === "phone-number" && (
                          <Field name={innerItem.titleName}>
                            {({ field, form }) => {
                              const isError = Boolean(
                                form.touched[innerItem.titleName] &&
                                  form.errors[innerItem.titleName]
                              );
                              return (
                                <>
                                  <CommonPhoneInput
                                    placeholder={innerItem?.placeholder}
                                    padding="14px 14px 14px 60px"
                                    country="us"
                                    value={localValue[innerItem.titleName]}
                                    onChange={(e, countryData) => {
                                      handleNumberChange(
                                        e,
                                        countryData,
                                        innerItem
                                      );
                                    }}
                                    disabled={true}
                                  />
                                  {isError && (
                                    <ErrorContent
                                      margin="-2px 0px 0px"
                                      className="Mui-error"
                                    >
                                      {form.errors[innerItem.titleName]}
                                    </ErrorContent>
                                  )}
                                </>
                              );
                            }}
                          </Field>
                        )}
                        {innerItem.component === "input" && (
                          <Field name={innerItem.titleName}>
                            {({ field, form }) => {
                              return (
                                <CommonTextField
                                  {...field}
                                  placeholder={
                                    innerItem?.placeholder
                                      ? innerItem?.placeholder
                                      : innerItem.title
                                  }
                                  disabled={innerItem?.disabled}
                                  padding="12px"
                                  error={Boolean(
                                    form.touched[innerItem.titleName] &&
                                      form.errors[innerItem.titleName]
                                  )}
                                  placeholderFontSize={
                                    innerItem?.placeholderFontSize
                                  }
                                  helperText={
                                    form.touched[innerItem.titleName] &&
                                    form.errors[innerItem.titleName]
                                  }
                                  maxLength={5}
                                  value={localValue[innerItem.titleName]}
                                  onChange={(e) =>
                                    handleInputChange(e, innerItem)
                                  }
                                />
                              );
                            }}
                          </Field>
                        )}

                        {innerItem.component === "country-data" && (
                          <Field name={innerItem.titleName}>
                            {({ field, form }) => {
                              const isError = Boolean(
                                form.touched[innerItem.titleName] &&
                                  form.errors[innerItem.titleName]
                              );
                              return (
                                <>
                                  <CommonPhoneInput
                                    country={
                                      values?.[innerItem?.titleName]
                                        ?.countryCode || ""
                                    }
                                    placeholder={innerItem?.placeholder}
                                    // value={
                                    //   ""
                                    // }
                                    onChange={(e, countryData) => {
                                      console.log(countryData, "countryData");
                                      setFieldValue(
                                        innerItem.country,
                                        countryData
                                      );
                                    }}
                                    padding="14px 0px 14px 60px"
                                    customStyle={{
                                      "& .selected-flag": {
                                        cursor: !innerItem.disabled
                                          ? "pointer"
                                          : "auto",
                                        borderRadius: "4px 0 0 4px",
                                      },
                                      "& .form-control ": {
                                        backgroundColor: "#f5f5f5 !important",
                                      },
                                      "& .flag-dropdown": {
                                        backgroundColor: "#fff !important",
                                      },
                                    }}
                                    disabled={innerItem.disabled}
                                    textDisabled={true}
                                  />

                                  {isError && (
                                    <ErrorContent
                                      margin="-2px 0px 0px"
                                      className="Mui-error"
                                    >
                                      {form.errors[innerItem.titleName]}
                                    </ErrorContent>
                                  )}
                                </>
                              );
                            }}
                          </Field>
                        )}
                        {innerItem.component === "input-number" && (
                          <Field name={innerItem.titleName}>
                            {({ field, form }) => {
                              return (
                                <CommonTextField
                                  {...field}
                                  placeholder={
                                    innerItem?.placeholder
                                      ? innerItem?.placeholder
                                      : innerItem.title
                                  }
                                  disabled={innerItem?.disabled}
                                  padding="12px"
                                  error={Boolean(
                                    form.touched[innerItem.titleName] &&
                                      form.errors[innerItem.titleName]
                                  )}
                                  placeholderFontSize={
                                    innerItem?.placeholderFontSize
                                  }
                                  helperText={
                                    form.touched[innerItem.titleName] &&
                                    form.errors[innerItem.titleName]
                                  }
                                  value={
                                    values.phone_number_country
                                      ? getFormattedValue(
                                          localValue[innerItem.titleName]
                                        )
                                      : localValue[innerItem.titleName]
                                  }
                                  // value={localValue[innerItem.titleName]}
                                  onChange={(e) =>
                                    handleInputNumberChange(e, innerItem)
                                  }
                                />
                              );
                            }}
                          </Field>
                        )}
                      </CommonGrid2>
                    ))}
                  </CommonGrid2>
                )}

                {item.component === "autoComplete" && (
                  <Field name={item.titleName}>
                    {({ field, form }) => {
                      const handleAutoCompleteChange = (e, newValue) => {
                        const checkData = form?.values[item.titleName];
                        if (e?.key === "Backspace" && e.target.value === "") {
                          const updatedValue = [
                            ...(form.values[item.titleName] || []),
                          ];
                          updatedValue.pop();
                          form.setFieldValue(item.titleName, updatedValue);
                        } else {
                          const formattedValues = newValue.map(
                            (item, index) => {
                              if (typeof item === "string") {
                                return {
                                  content: item,
                                  ...(checkData[0]?.name
                                    ? { name: "inferred" }
                                    : { id: index }),
                                };
                              }
                              return item;
                            }
                          );

                          form.setFieldValue(item.titleName, formattedValues);
                        }
                      };

                      const handleDelete = (option) => {
                        const updatedValue = form.values[item.titleName].filter(
                          (item, i) => item !== option
                        );
                        form.setFieldValue(item.titleName, updatedValue);
                      };

                      const handleKeyDown = (e) => {
                        const checkData = form?.values[item.titleName];
                        const dataValue = e.target.value;
                        if (e.key === "Tab") {
                          e.preventDefault();
                          setLocalValue((prev) => ({
                            ...prev,
                            [item.inputValue]: "",
                          }));

                          if (dataValue !== "") {
                            const data = {
                              content: dataValue,
                              ...(checkData[0]?.name
                                ? { name: "inferred" }
                                : { id: index }),
                            };

                            const formattedValues = [...checkData, data];
                            form.setFieldValue(item.titleName, formattedValues);
                            form.setFieldValue(item.inputValue, "");
                          }
                        }
                      };

                      const isError =
                        form.touched[item.titleName] &&
                        form.errors[item.titleName];
                      const helperText = isError
                        ? form.errors[item.titleName]
                        : "";
                      return (
                        <>
                          <AutocompleteText
                            autoData={{
                              options: [],
                              key: `autocomplete-${index}`,
                              title: "Select Emails",
                              placeholder: item.placeholder,
                              isDisabled: item.disabled,
                              value: form.values[item.titleName] || "",
                              onDelete: handleDelete,
                              onKeyDown: handleKeyDown,
                              onChange: handleAutoCompleteChange,

                              inputValue: localValue[item.inputValue],
                              onInputChange: (e, newValue) => {
                                setLocalValue((prev) => ({
                                  ...prev,
                                  [item.inputValue]: newValue,
                                }));
                              },
                              limitTags: item.disabled
                                ? form.values[item.titleName]?.length
                                : true,
                            }}
                            error={isError}
                          />
                          {isError && (
                            <ErrorContent margin={"-5px 0px 0px"}>
                              {helperText}
                            </ErrorContent>
                          )}
                        </>
                      );
                    }}
                  </Field>
                )}
              </>
            )}
          </CommonGrid2>
        );
      })}
    </CommonGrid2>
  );
};
export default SubmissionMixedComponent;
